export default __webpack_public_path__ + "static/media/project1.ca88974f.png";